import { render, staticRenderFns } from "./ConfigIntegrationSecurityProperties.vue?vue&type=template&id=6109aa60&scoped=true&"
import script from "./ConfigIntegrationSecurityProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationSecurityProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationSecurityProperties.vue?vue&type=style&index=0&id=6109aa60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6109aa60",
  null
  
)

export default component.exports